<app-header></app-header>
<div class="content_wrapper">
    <div [style.display]="display">
        <table id="mentions-table"> 
            <tr>       
                <th>ID</th> 
                <th>Date</th>  
                <th>Title</th> 
                <th>Content</th>   
                <th>Source</th>   
                <th>Domain</th>   
                <th>Category</th>   
                <th>Sentiment</th>   
                <th>Tags</th>   
            </tr>    
            <tr *ngFor="let mention of mentions;" [style.display]="can_show_mention(mention.id, mention.profile_id)">
                <th>{{mention.id}}</th> 
                <th>{{change_date_format(mention.pub_datetime, 'YYYY-MM-DD hh:mm a')}}</th>  
                <th>{{mention.title ? mention.title : mention.name}}</th> 
                <th>{{mention.description}}</th>   
                <th>{{mention.link}}</th>   
                <th>{{mention.link.split("/")[2]}}</th>   
                <th>{{mention.mchannel}}</th>   
                <th>{{mention.sentiment_text}}</th>   
                <th>{{mention.campaign}}</th>   
            </tr> 
        </table>

        <table id="summary-table"> 
            <tr>       
                <th>Type</th> 
                <th>Count</th>  
                <th>Percentage</th>  
            </tr>    
            <tr>
                <td>Positive</td>  
                <td>{{summary.positive}}</td> 
                <td>{{summary.percentage_positive}}</td> 
            </tr> 
            <tr>
                <td>Negative</td>  
                <td>{{summary.negative}}</td> 
                <td>{{summary.percentage_negative}}</td> 
            </tr> 
            <tr>
                <td>Neutral</td>  
                <td>{{summary.interactions}}</td> 
                <td>{{summary.percentage_neutral}}</td> 
            </tr> 
            <tr>
                <td></td>  
                <td></td> 
                <td></td> 
            </tr> 
            <tr>
                <td>Total</td>  
                <td>{{summary.total}}</td> 
                <td></td> 
            </tr> 
        </table>

        <table id="category-table"> 
            <tr>       
                <th>Category</th> 
                <th>Number of Mentions</th>   
            </tr>    
            <tr *ngIf="categories.web">
                <td>Web</td>  
                <td>{{categories.web}}</td> 
            </tr> 
            <tr *ngIf="categories.twitter">
                <td>Twitter</td>  
                <td>{{categories.twitter}}</td> 
            </tr> 
            <tr *ngIf="categories.instagram">
                <td>Instagram</td>  
                <td>{{categories.instagram}}</td> 
            </tr> 
            <tr *ngIf="categories.facebook">
                <td>Facebook</td>  
                <td>{{categories.facebook}}</td> 
            </tr> 
            <tr *ngIf="categories.youtube">
                <td>Youtube</td>  
                <td>{{categories.youtube}}</td> 
            </tr> 
            <tr *ngIf="categories.reviews">
                <td>Reviews</td>  
                <td>{{categories.reviews}}</td> 
            </tr> 
<!--            <tr *ngIf="categories.others">
                <td>Others</td>  
                <td>{{categories.others}}</td> 
            </tr> -->
            <tr *ngIf="categories.others">
                <td>Linkedin</td>  
                <td>{{categories.linkedin}}</td> 
            </tr> 
            <tr *ngIf="categories.others">
                <td>Others</td>  
                <td>{{categories.reddit}}</td> 
            </tr> 
        </table>

        <table id="numerical-table"> 
            <tr>       
                <th>Date</th> 
                <th>Mentions Count</th>   
                <th>Positive Mentions Count</th>   
                <th>Negative Mentions Count</th>   
            </tr>    
            <tr *ngFor="let date of numerical.dates;">
                <td>{{change_date_format(date, 'YYYY-MM-DD')}}</td>  
                <td>{{numerical.data[date] ? numerical.data[date] : 0}}</td> 
                <td>{{numerical.positive_data[date] ? numerical.positive_data[date] : 0}}</td> 
                <td>{{numerical.negative_data[date] ? numerical.negative_data[date] : 0}}</td> 
            </tr> 
        </table>
    </div>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>
<app-footer></app-footer>